import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M22.905 7.332c-.028-.757-.028-1.485-.028-2.184 0-.553-.418-.99-.947-.99-4.096-.03-7.216-1.253-9.807-3.874a.93.93 0 0 0-1.337 0c-2.59 2.621-5.711 3.845-9.778 3.845-.53 0-.948.436-.948.99 0 .699 0 1.427-.028 2.213-.139 7.195-.334 17.01 11.116 21.146.112.029.195.058.307.058.111 0 .223-.03.306-.058 11.45-4.136 11.255-13.952 11.144-21.146Zm-11.45 19.136C1.648 22.74 1.788 14.585 1.927 7.391c0-.437.028-.845.028-1.253 3.816-.204 6.881-1.398 9.5-3.786 2.618 2.388 5.683 3.611 9.5 3.757 0 .408 0 .816.028 1.253.139 7.223.278 15.378-9.528 19.106Z",
  fill: "url(#guarantee-icon-fill-a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.742 10.799-4.597 4.805-1.978-2.067c-.362-.38-.975-.38-1.365 0-.362.378-.362 1.019 0 1.427L9.45 17.73a.886.886 0 0 0 .668.29c.251 0 .502-.087.669-.29l5.293-5.534c.362-.379.362-1.02 0-1.427a.906.906 0 0 0-1.337.029Z",
  fill: "url(#guarantee-icon-fill-b)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "guarantee-icon-fill-a",
  x1: "11.464",
  y1: "0",
  x2: "11.464",
  y2: "28.536",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00B0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#0083FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "guarantee-icon-fill-b",
  x1: "11.441",
  y1: "10.489",
  x2: "11.441",
  y2: "18.022",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00B0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#0083FF"
})))), 'Guarantee', {
  viewBox: '0 0 23 29'
});